<template lang="pug">
.stepbystep
    .stepbystep-item(
        v-for='(step, i) in stepsView',
        :id='"step" + i',
        :key='i',
        :href='step.link',
        @click="$emit('step:step-change', step)"
        :class='step.completed ? "--completed" : ""'
    )
        .step-content(
            :style='[stepsView.length === i + 1 ? { width: "90px" } : ""]',
            :class='step.isEditing ? "--editing" : ""'
        )
            .icon-stepbystep.--editing.mdi.mdi-pencil-outline(v-if='step.isEditing')
            .icon-stepbystep.--completed.mdi.mdi-check(v-else-if='step.completed')
            .icon-stepbystep.--jump.mdi.mdi-redo(v-else-if='step.jump')
            .icon-stepbystep.--incomplete.mdi.mdi-checkbox-blank-circle-outline(v-else)
            .stepbystep-label(v-if='step.label')
                a {{ step.label }}
        .line(v-if='stepsView.length !== i + 1', :class='step.completed ? "--completed" : ""')
</template>

<script>
export default {
    name: 'StepByStepComponent',
    props: {
        value: {},
        id: {
            type: String,
            default: () => `step-by-step-${Math.ceil(Math.random() * 10000)}`,
        },

        list: {
            type: Array,
            required: true,
        },
    },
    computed: {
        stepsView() {
            const view = [...this.list];
            const stepAtual = view.find((step) => step.codigo === this.value);
            if (stepAtual) {
                for (const step of view) {
                    if (step !== stepAtual) {
                        step.isEditing = false;
                    }
                    // step.completed = step.posicao < stepAtual.posicao;
                }
                stepAtual.isEditing = true;
            }
            return view;
        },
    },
};
</script>

<style>
.step-content {
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 200px;
}

.line {
    top: -20px;
    width: 100%;
    height: 5px;
    border-bottom: 3px solid var(--primary-black);
    position: relative;
}

.line.--completed {
    border-bottom: 3px solid rgb(77 168 51);
}

.stepbystep {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;

    margin: 20px;
    padding: 10px;
}

.stepbystep-item {
    display: flex;
    flex-direction: row;
    align-items: center;

    pointer-events: none;

    width: 150px;
}

.--completed {
    pointer-events: auto;
    color: rgb(77 168 51);
    cursor: pointer;
}

.--incomplete {
    pointer-events: auto;
    cursor: pointer;
}

.--editing {
    font-weight: bolder;
    color: rgb(18 99 45);
}

.--jump {
    font-weight: bolder;
    color: royalblue;
}

.icon-stepbystep {
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 3px;

    border-radius: 50%;

    background-color: var(--primary-gray);
}

.icon-stepbystep.--completed {
    background-color: rgb(77 168 51);
    color: var(--primary-white) !important;
}

.icon-stepbystep.--editing {
    background-color: rgb(18 99 45);
    color: var(--primary-white) !important;
}

.icon-stepbystep.--jum {
    background-color: royalblue;
    color: var(--primary-white) !important;
}


.stepbystep-label {
    padding: 10px;
}

/* .stepbystep-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
}

.stepbystep-item::before {
    position: absolute;
    content: "";
    border-bottom: 2px solid #ccc;
    width: 100%;
    top: 20px;
    left: -50%;
    z-index: 2;
}

.stepbystep-item::after {
    position: absolute;
    content: "";
    border-bottom: 2px solid #ccc;
    width: 100%;
    top: 20px;
    left: 50%;
    z-index: 2;
}

.stepbystep-icon {
    position: absolute;
    content: "";
    border-bottom: 2px solid #ccc;
    width: 100%;
    top: 20px;
    left: 50%;
    z-index: 2;
}

.stepbystep-icon.completed {
background-color: #4bb543;
color: #4bb543;
}



.--active {
  font-weight: bold;
}

.--completed::after {
    position: absolute;
  content: "";
  border-bottom: 2px solid #4bb543;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 3;
} */
</style>
